export type Constructor<T> = new (...args: any[]) => T;

export class RootMixin {}

export { UserAwareMixin, DestroyableMixin } from './base.mixins';

export { WithMenubarMixin } from './layout.mixins';

export { DataTableMixin } from './data.mixins';
